module.exports = __webpack_public_path__ + "static/media/audio.5aec8a7a.svg";